import { SACard } from "@saux/design-system-react";
import { useState, useEffect } from "react";
import SimpleSearch from "../simpleSearch/SimpleSearch";
import AdvancedSearch from "../advancedSearch/AdvancedSearch";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ADVANCED_SEARCH, CUSTOMER, NEW, RECEIVED, SEND, SIMPLE_SEARCH } from "../../utils/constants";
import "./SearchClaim.css";
import { handleSubscriptionError, setAlert, simpleGTMDataLayer, twoStringsAreEqual, updateConversationsOrderCC } from "../../utils/utilities";
import fetchConversations, { fetchConversationById, fetchUnreadMessagesCountById, formatSelectedConversation } from "../../store/actions/conversationActions";
import { updateInitialState } from "../../store/action-creators/conversationActionCreator";
import { loader } from "graphql.macro";
import { executeGraphqlSubscribe } from "../../graphql/api";
const receiveMessagesSubscription = loader(
  "../../graphql/subscriptions/receiveMessagesByAdjusterId.graphql"
);


const SearchClaim = (props: any) => {
  const [isAdvancedType, setAdvancedType] = useState(false);
  const user = useSelector((state: any) => state.user);
  let history = useNavigate();
  let location = useLocation();
  const dispatch = useDispatch();
  let messageSubscription: any;

  const toggleSearch = (isAdvanced: boolean) => {
    history(`/search?advancedSearch=${isAdvanced}`);
  }

  useEffect(()=>{
    subscribeToMessage();
    dispatch(fetchConversations({ adjusterId: user?.email, isArchived: false },
      (res)=>{
       console.log(res);
    }));
    return () => {
      dispatch(updateInitialState());
      messageSubscription.unsubscribe();
    };
  },[]);

  useEffect(() => {
    let search = location && location.search;
    // props.setPath(path);
    let searchValues = search?.slice(1).split("=");
    if (searchValues[0] === "advancedSearch") {
      setAdvancedType(searchValues[1] === "true");
    }
  }, [location.search]);

  const createConversation = (claimant: any) => {
    const conversation = {
      adjusterId: user.email,
      claimNumber: claimant.claim_number,
      conversationId: NEW,
      participants: [{
        name: claimant.first_name + " " + claimant.last_name,
        phoneNumber: claimant.claimant_phone_number,
        participantType: CUSTOMER
      }],
    }
    fetchConversationById({ claimNumber: conversation.claimNumber, phoneNumber: conversation.participants[0].phoneNumber }, user.email,
      (res: any) => {
        if (res && res.archiveStatus) {
          const var_data = JSON.stringify(res);
          sessionStorage.setItem(user.email, var_data);
          sessionStorage.setItem('archiveConversation', res.conversationId);
          updateConversationsOrderCC(res);
          dispatch(formatSelectedConversation(res));
          history(`/archived-conversations?id=${res.conversationId}`);
        } else {
          const var_data = JSON.stringify(res);
          sessionStorage.setItem(user.email, var_data);
          updateConversationsOrderCC(res);
          dispatch(formatSelectedConversation(res));
          props.setPath("/message")
          history(`/message?id=${res.conversationId}`);
        }

      }, (error: any) => {
        console.log(error);
      }
    )
  }

  const subscribeToMessage = () => {
    messageSubscription = executeGraphqlSubscribe(
      receiveMessagesSubscription
    ).subscribe({      next: ({ provider, value }: any) => {
        let messageResponse = value?.data?.onCreateMessageByAdjusterId;
          if (messageResponse.message) {
            let type = twoStringsAreEqual(user?.email, messageResponse?.from.id)
              ? SEND
              : RECEIVED;
            let newMsgDetails = {
              type: type,
              conversationId: messageResponse?.conversationId,
              fromId: messageResponse?.from.id
            };          
             if(type===RECEIVED){
              dispatch(fetchUnreadMessagesCountById(messageResponse?.conversationId));
              setAlert(newMsgDetails);
            }

          }
      },
      error: ({ error, provider }: any) => {
        handleSubscriptionError(error);
      },
    });
  };

  const handleSearchType = () => {
    setAdvancedType(!isAdvancedType);
    toggleSearch(!isAdvancedType);
  }

  return (
    <div data-testid="search-claim" style={{ height: "100%" }}>
      <SACard variant="minimal" height={70}>
        <div style={{ display: "flex" }}>
          <div><span style={{ fontSize: "larger", color: "black" }}>Insured/Claimants Lookup</span></div>
          <div style={{ marginLeft: "auto" }}>
            <div data-testid="search-type" style={{ color: "green", fontWeight: "bold", cursor: "pointer" }} onClick={handleSearchType}><span style={{ textTransform: "uppercase" }}>{isAdvancedType ? SIMPLE_SEARCH : ADVANCED_SEARCH}</span></div>
          </div>
        </div>
      </SACard>
      {isAdvancedType === true ? <AdvancedSearch createConversation={createConversation} /> : <SimpleSearch createConversation={createConversation} />}
    </div>
  );
};

export default SearchClaim;

